var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.title)?_c('Txt',{attrs:{"bold":true}},[_vm._v(_vm._s(_vm.t(_vm.title)))]):_vm._e(),_c('div',{class:'form-group-inner ' + _vm.cls},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }